import { type ClassValue, clsx } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

// Re-export keyboard shortcuts utilities
export { useKeyboardShortcuts, GLOBAL_SHORTCUTS, shouldReceiveKeyboardFocus } from './keyboard-shortcuts';